module.exports = __webpack_public_path__ + "img/1f990.bd249ab.svg";